import React, { FC } from 'react';
import css from './UpsellSelectionBanner.module.scss';

const UpsellSelectionBanner: FC = () => {
    const fullIconPath = `${require('./img/submarine.jpg')}`;
    return (
        <div className={css.upsellSelectionBannerCardWrapper}>
            <div
                className={css.upsellSelectionBannerCardRoot}
                role="none"
            >
                <img
                    className={css.upsellSelectionBannerIconWrapper}
                    src={fullIconPath}
                    alt="selection_icon"
                />
                <div className={css.upsellSelectionBannerTextBlock}>
                    <div>Подарок к завтраку</div>
                    <div>кофе от Submarine</div>
                    <div className={css.upsellSelectionBannerPromoText}>
                        Реклама ООО «Ростинг Брю» ИНН 7720380817 Erid 2SDnjdQvUv2
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpsellSelectionBanner;
